export default "__VITE_ASSET__D0RAUeU3__"